import { ConfigurationAssayResponse } from '@/modules/configurationModule/detail/assays/configuration-assays/services/configuration-assay/configuration-assay.dto'
import { ConfigurationAutomaticOntologyAssayResponse } from '@/modules/configurationModule/detail/automation/assays/services/configuration-automatic-ontology-assay/configuration-automatic-ontology-assay.dto'
import { ConfigurationOntologyForAutomaticAssayResponse } from '@/modules/configurationModule/detail/automation/assays/services/configuration-ontology-for-automatic-assay/configuration-ontology-for-automatic-assay.dto'
import { Nullable } from '@/shared/types/app.types'
import { store } from '@/store/store'

export interface ConfigurationAutomationAssaysModalAssaysFormState {
    ontologyForAutomaticAssay: Nullable<ConfigurationOntologyForAutomaticAssayResponse>
    assays: ConfigurationAssayResponse[]
    automaticOntologyAssays: ConfigurationAutomaticOntologyAssayResponse[]
    laboratoryId: number
}
export const initialConfigurationAutomationAssaysModalAssaysFormState =
    (): ConfigurationAutomationAssaysModalAssaysFormState => ({
        ontologyForAutomaticAssay: null,
        assays: [],
        automaticOntologyAssays: [],
        laboratoryId: store.getters.labId
    })
